<template lang="pug">
.fb-element(
    :class="{ 'is-selected': selected, 'is-presentational': isPresentational }"
)
    .fb-element-header(
        :class="{ 'fb-handle': edit }"
        @click.stop="$emit('select', element)"
    )
        .fb-element-handle(v-if="edit")
            i.el-icon-fa-grip-vertical.fas
        .fb-element-icon
            span.fb-element-svg(v-if="svg" v-html="svg")
            i(v-else :class="icon")
        .fb-element-body
            .fb-element-label {{ element.label || typeName }}
            .fb-element-meta
                span.fb-element-type {{ typeName }}
                span.fb-element-required(v-if="element.required") {{ $t('required') }}
        i.fb-element-chevron(
            v-if="edit"
            :class="selected ? 'el-icon-fa-chevron-up fas' : 'el-icon-fa-chevron-down fas'"
        )
        i.fb-element-lock(
            v-if="edit && locked"
            :title="$t('required field')"
            class="el-icon-fa-lock fas"
        )
        el-button.fb-element-delete(
            v-else-if="edit"
            circle
            size="mini"
            type="danger"
            icon="el-icon-fa-trash-can fas"
            @mousedown.native.stop
            @click.stop="$emit('delete', element)"
        )
    .fb-element-settings(v-if="edit && selected" @click.stop)
        form-builder-element-settings(
            :element="element"
            embedded
            :options="options"
            @change="$emit('change')"
        )
</template>

<i18n>
{
    "en": { "required": "required", "required field": "Required field – cannot be removed" },
    "de": { "required": "Pflicht", "required field": "Pflichtfeld – kann nicht entfernt werden" }
}
</i18n>

<script>
import { elementIcon, elementSvg, elementTypeName, isLockedType } from './palette'
import FormBuilderElementSettings from './FormBuilderElementSettings'

export default {
    name: 'FormBuilderElement',
    components: { FormBuilderElementSettings },
    props: {
        element: { type: Object, required: true },
        selected: { type: Boolean, default: false },
        edit: { type: Boolean, default: true },
        options: { type: Object, default: () => ({}) },
    },
    computed: {
        icon() {
            return elementIcon(this.element.type)
        },
        svg() {
            return elementSvg(this.element.type)
        },
        typeName() {
            return elementTypeName(this.element.type)
        },
        isPresentational() {
            return this.element.role === 'presentational'
        },
        locked() {
            return isLockedType(this.element.type)
        },
    },
}
</script>

<style lang="sass" scoped>
.fb-element
    background: #fff
    border: 1px solid #e4e7ed
    border-radius: 6px
    transition: border-color .15s, box-shadow .15s
    &:hover
        border-color: #c0c4cc
    &.is-selected
        border-color: $--color-primary
        box-shadow: 0 0 0 1px $--color-primary
    &.is-presentational
        background: #f8f9fb
        border-style: dashed
.fb-element-header
    display: flex
    align-items: center
    gap: .45rem
    padding: .25rem .5rem
    min-height: 2rem
    cursor: grab
    &:active
        cursor: grabbing
.fb-element-handle
    color: #c0c4cc
    flex: 0 0 auto
    font-size: .8rem
.fb-element-icon
    flex: 0 0 auto
    width: 1.25rem
    text-align: center
    color: $--color-primary
    font-size: .85rem
    .fb-element-svg
        display: inline-flex
    ::v-deep svg
        width: .85rem
        height: .85rem
        display: block
.fb-element-body
    flex: 1 1 auto
    min-width: 0
    display: flex
    align-items: baseline
    gap: .4rem
.fb-element-label
    font-weight: 600
    font-size: .85rem
    line-height: 1.2
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
.fb-element-meta
    display: flex
    gap: .35rem
    align-items: baseline
    font-size: .68rem
    color: #909399
    flex: 0 0 auto
.fb-element-required
    color: $--color-danger
.fb-element-chevron
    flex: 0 0 auto
    color: #c0c4cc
    font-size: .75rem
.fb-element-delete
    flex: 0 0 auto
.fb-element-lock
    flex: 0 0 auto
    color: #c0c4cc
    font-size: .8rem
    padding: 0 .3rem
    cursor: default
.fb-element-settings
    border-top: 1px solid #ebeef5
    cursor: default
</style>
